import { render, staticRenderFns } from "./newaccount-full.vue?vue&type=template&id=3e52f307&"
import script from "./newaccount-full.vue?vue&type=script&lang=js&"
export * from "./newaccount-full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports